

import AuthPage from "../../components/layout/authPage"
import { Col, Row, SubTitle, TabButtons, TabButtonsItem, Text, Title, VImage } from "../../style/base.style"
import { doctorBanner, facebookIcon, googleIcon, loginBanner } from "../../constants/images"
import { use, useEffect, useState } from "react"
import { useDeviceType } from "../../contexts/DeviceContext"
import { RegistrationComponent } from "../../components/authentication/registration"
import { PartnerLoginComponent } from "../../components/authentication/partnerLogin"
import { FieldType, TextFieldType } from "../../components/fields"
import Joi from "joi"
import { useFormHandling } from "../../hooks/formUtils"
import { RequestConfigs } from "../../api"
import { FormComponent } from "../../components/form"
import { ActionButton } from "../../components/buttons/ActionButton"
import { useDictionary } from "../../contexts/dictionary"




export const SearchMemberPage = () => {

  useEffect(() => {
    document.body.classList.add("contact-page");

    return () => document.body.classList.remove("contact-page");
  }, []);

  const [contact, setContact] = useState<Contact | null>(null);
  const { handleClick,handleInputChange,serverRes } = useFormHandling({ requestType: RequestConfigs.vendorSearchMember })
  const {translate} = useDictionary()

  const formFields: FieldConfig[] = [
    {
      type: FieldType.text,
      name: "govId",
      label: translate("gov_id_label"),
      joiSchema: Joi.string().required(),
      typeOptions: {
        type: TextFieldType.search,
      }
    },
  ]


  useEffect(() => {
    if(serverRes) {
      console.log("Search result:", serverRes);
      setContact(serverRes.contactDetails || null);
      
    }
  }, [serverRes]);

const {isMobile} = useDeviceType()
    return (
      <AuthPage>
        <div className="content" style={{ justifyContent: "center", alignItems: "center",justifyItems: "center", width: "100%" }}>
         <Col $width="500px" $padding="20px" className="search-member-container" $justifyContent="center" $alignItems="center">
         <SubTitle $margin="0 0 20px 0">{translate("search_member")}</SubTitle>
                      <FormComponent
                        fields={formFields}
                        onChange={handleInputChange}
                        serverRes={serverRes}
                      />
                      <ActionButton
                      width="150px"
                        onClick={handleClick}
                        label={translate("search")}
                      />
                    </Col>

                    {
                        contact && 
                        <Col $width="80%" $padding="20px" className="search-member-result" $justifyContent="center" $alignItems="center">
                            <SubTitle $margin="0 0 20px 0">{translate("member_details")}</SubTitle>
                            <Text>{`${translate("status")}: ${translate("active_subscription")}`}</Text>
                            <Text>{`${translate("name")}: ${contact.Full_Name}`}</Text>
                                <Text>{`${translate("email_label")}: ${contact.Email}`}</Text>
                                <Text>{`${translate("phone_label")}: ${contact.Phone}`}</Text>
                        </Col>
                    }
        </div>
      </AuthPage>
        
    )

}